import config from "@Config/index";
import axios from "axios";
import getMiniProgramDataCSR from "./getMiniProgramDataCSR";

function stringifyTopLevelBooleans(obj: Record<string, any>): Record<string, any> {
  const newObj: Record<string, any> = {};
  Object.entries(obj).forEach(([key, value]) => {
    newObj[key] = typeof value === "boolean" ? value.toString() : value;
  });
  return newObj;
}

export const trackMpGAEvent = async ({
  event_name,
  event_params,
  source = "website",
}: {
  event_name: string;
  event_params: Record<string, any>;
  source?: string;
}) => {
  const { clientId = "", sessionId = "" } = getMiniProgramDataCSR() ?? {};
  if (!event_name || !clientId) return;
  const stringified_event_params = stringifyTopLevelBooleans(event_params);
  const cleanEventParams = JSON.stringify(stringified_event_params);
  try {
    await axios.post(`${config.API_URL}/api/v0/services/track_ga_event`, {
      event_name,
      event_params: cleanEventParams,
      client_id: clientId,
      session_id: sessionId,
      source,
    });
  } catch (err) {
    console.error("GA track error:", err);
  }
};
export default trackMpGAEvent;
